define([
	"dojo/_base/declare",
	"csi/xml",
	"csi/xml/Query",
	"./MassAddMaterial",
	"./MassCreateDependentPartMaterialForm"
], function(declare, xml, Query, MassAddMaterial) {

	return declare(MassAddMaterial, {
		_queryPath: "Child:__Parent__/Child:__Parent__/Child:__Parent__",
		_classController: "MaterialSpecProductSpec/MassCreateDependentPartMaterialForm",
		_operation: "PartMaterialMassCreateDependent",
		_subtypeSettings: "Child:__Parent__/Child:__Parent__/Child:__Parent__/Child:__Parent__/Child:Subtype/Child:Settings",

		/**
		 * @override
		 * Maps the list of PartMaterials to get list of ProductBOMRevisions
		 */
		getSelectedValues: function(fd) {
			return fd.getSelectedNodes().map(p => p.__Parent__);
		},

		_getContextApparelBOMRevisionNode: function(ctx) {
			return ctx.getNodeParent();
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
				 /*csi.wizard.Content*/currentPage,
				 /*csi.wizard.Content*/nextPage,
				 /*Boolean*/bFinish) {

			if (wizard.getIndexOfPage(nextPage) == 1) {
				//the WhereUsed in Style BOM view on Material is being reused to show placements that have the dependent material
				// the value of dependent material field from current page in the wizard needs to be set for the WhereUsedApparelBOM viewRef
				var fd = this.m_formData;
				var dependentMaterialField = fd.getFieldValue(currentPage.getView().FIELD_DEPENDENT_MATERIAL);
				fd.setNode(this.m_cache.getNode(dependentMaterialField, true));
			}

			return this.inherited(arguments);
		},

		getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: return query for BOM-lines view
			let q;

			if (index == 0) {
				q = this.inherited(arguments);
			} else if (index == 1) {
				// table view of all BOMs (revisions) that the current revision is in Draft state, and satisfy the Season
				const filter = this.m_formData.getFieldValue(this._fieldFilter);
				let filterFieldName;
				if (this._isApparelBOMAction) {
					filterFieldName = "ParentSeason";
				} else if (this._isThemeBOMAction) {
					filterFieldName = "ThemeSeasons";
				} else {
					filterFieldName = "ProductType";
				}

				q = new Query();
				if (this._isThemeBOMAction) {
					q.Or()
						.RefAttr(filterFieldName, xml.OP_EQUALS, filter, this._queryPath)
						.Attr("ThemeToSeason", xml.OP_EQUALS, "ThemeToSeason:AllSeasons", this._subtypeSettings);
				} else {
					q.RefAttr(filterFieldName, xml.OP_EQUALS, filter, this._queryPath);
				}
				q.Not().RefAttr("BOMMaterials", xml.OP_EQUALS, this.m_urlParent, "Child:__Parent__");
				q.Attr("State", xml.OP_EQUALS, "Revision.State:DRAFT", "Child:__Parent__")
				q.Attr("IsSampleBOM", xml.OP_NOT_EQUALS, true, "Child:__Parent__/Child:__Parent__");
			}

			return q;
		}

	});
});
